module.exports = __webpack_public_path__ + "img/oland-l.9d540b74.png";